import Link from "@/components/common/Link";

export const DesktopNavDropdownItem = ({
    title,
    onClick,
    url,
}: {
    title: string;
    onClick: () => void;
    url?: string;
}) => {
    return (
        <Link
            href={url ?? "#"}
            onClick={onClick}
            className="w-full bg-white dark:bg-darkSurface-200 text-black dark:text-white hover:bg-irBlue-600 dark:hover:bg-darkSurface-300 hover:text-white px-4 py-2 text-left"
        >
            {title}
        </Link>
    );
};
